import {
    DELIVERYDATES_SET,
    DELIVERYDATES_LOADER
} from '../constants';
import { error as errorReducer } from './Error.reducer';
const defaultState = {
    deliveryDate: null,
    dispatchMethod: null,
    loading: false
}
export const deliveryDate = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {    
        case DELIVERYDATES_SET:
        case DELIVERYDATES_LOADER:
            return {
                ...state,
                ...payload
            };
        default:
            return state;
    }
};
